/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useQuery, useQueryClient } from 'react-query';
import axios from 'axios';

import cacheKeys from './cacheKeys';
export const getCurrentUser = async () => {
  const { data } = await axios.get('/organizations/account_details');
  return data;
};

export const useCurrentUser = (initalUser: any) =>
  useQuery(cacheKeys.CURRENT_USER, getCurrentUser, {
    staleTime: Infinity,
    cacheTime: Infinity,
    initialData: initalUser,
  });

export const useUserMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (updatedUser) => axios.patch('/users/update', updatedUser),
    {
      onSuccess: ({ data }) => {
        queryClient.invalidateQueries(cacheKeys.PAYMENTS);
        queryClient.setQueryData(
          cacheKeys.CURRENT_USER,
          (old: Record<string, unknown>) => ({
            ...old,
            first_name: data.first_name,
            last_name: data.last_name,
          })
        );
      },
    }
  );
};

export const usePasswordMutation = () =>
  useMutation(async (updatedUser) => {
    const { data } = await axios.patch('/users/update-password', updatedUser);
    return data;
  });

export const logout = async () => {
  await axios.delete('/users/sign_out.json');
  window.location.href = '/users/sign_in';
};
